import { renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';
import {
  buildHousingBurdenNarrativeFacts,
  type HousingBurdenMetricsInput,
  type HousingBurdenNarrativeFacts,
  type HousingBurdenViewId,
} from './peopleHousingBurdenNarrativeFacts';

const CHART_ID = 'housing_burden';

function tokensFromFacts(f: HousingBurdenNarrativeFacts): Record<string, string> {
  return {
    locationName: f.locationName,
    comparisonYear: f.comparisonYear != null ? String(f.comparisonYear) : '—',
    latestYear: f.comparisonYear != null ? String(f.comparisonYear) : '—',
    latestRenterYear: f.latestRenterYear != null ? String(f.latestRenterYear) : '—',
    latestOwnerYear: f.latestOwnerYear != null ? String(f.latestOwnerYear) : '—',
    renter35Plus: f.renter35Plus != null ? f.renter35Plus.toFixed(1) : '—',
    owner35Plus: f.owner35Plus != null ? f.owner35Plus.toFixed(1) : '—',
    renterPercentile:
      f.renterPercentile != null ? String(Math.round(f.renterPercentile)) : '—',
    ownerPercentile:
      f.ownerPercentile != null ? String(Math.round(f.ownerPercentile)) : '—',
    comparisonSentence: f.comparisonSentence,
    trendSentence: f.trendSentence,
    renter35Sentence: f.renter35Sentence,
    owner35Sentence: f.owner35Sentence,
    ownerDistributionSentence: f.ownerDistributionSentence,
    percentileContextSentence: f.percentileContextSentence,
    largestRenterBurdenBand: f.largestRenterBurdenBand,
    largestRenterBurdenShare:
      f.largestRenterBurdenShare != null ? f.largestRenterBurdenShare.toFixed(1) : '—',
    renterTrendSentence: '',
    ownerTrendSentence: '',
  };
}

export function buildHousingBurdenAuthoredBundle(facts: HousingBurdenNarrativeFacts) {
  const bundle = renderAuthoredNarrativeBundle(
    CHART_ID,
    facts.viewId,
    tokensFromFacts(facts)
  );
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}

export function buildHousingBurdenAuthoredFromMetrics(
  locationName: string,
  viewId: HousingBurdenViewId,
  metrics: HousingBurdenMetricsInput
) {
  const facts = buildHousingBurdenNarrativeFacts({
    locationName,
    viewId,
    ...metrics,
  });
  return buildHousingBurdenAuthoredBundle(facts);
}
